
export const mockProducts = [
  {
    id: 'prod_001',
    model_name: 'Royal Diamond Ring',
    category: 'Rings',
    metal_type: 'Gold',
    purity: '18K',
    grossWeight: 5.2,
    netWeight: 4.8,
    stoneWeight: 0.4,
    stone_details: 'Diamond 0.5ct',
    making_charges: 2500,
    vendor_name: 'Elegant Jewels',
    description: 'Stunning diamond ring with intricate gold work',
    price: 45000,
    cost: 38000,
    status: 'active',
    images: ['https://public.readdy.ai/ai/img_res/28ed9dabeca1b61010ffcf060c658959.jpg'],
    created_at: '2024-01-15T10:00:00Z',
    updated_at: '2024-01-15T10:00:00Z'
  },
  {
    id: 'prod_002',
    model_name: 'Classic Gold Chain',
    category: 'Necklaces',
    metal_type: 'Gold',
    purity: '22K',
    grossWeight: 12.5,
    netWeight: 12.5,
    stoneWeight: 0,
    stone_details: 'None',
    making_charges: 1800,
    vendor_name: 'Golden Heritage',
    description: 'Traditional gold chain with fine craftsmanship',
    price: 85000,
    cost: 78000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=traditional%2022k%20gold%20chain%20necklace%2C%20thick%20rope%20chain%20design%2C%20yellow%20gold%20finish%2C%20classic%20Indian%20jewelry%20style%2C%20heavy%20weight%20gold%20chain%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=gold_chain_002&orientation=squarish'],
    created_at: '2024-01-16T11:00:00Z',
    updated_at: '2024-01-16T11:00:00Z'
  },
  {
    id: 'prod_003',
    model_name: 'Pearl Drop Earrings',
    category: 'Earrings',
    metal_type: 'Silver',
    purity: '925',
    grossWeight: 3.8,
    netWeight: 3.2,
    stoneWeight: 0.6,
    stone_details: 'Pearl 6mm',
    making_charges: 800,
    vendor_name: 'Pearl Paradise',
    description: 'Elegant pearl earrings in sterling silver',
    price: 12000,
    cost: 9500,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=elegant%20white%20pearl%20drop%20earrings%20in%20sterling%20silver%2C%20lustrous%20freshwater%20pearls%2C%20delicate%20silver%20hooks%2C%20classic%20bridal%20jewelry%2C%20sophisticated%20design%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=pearl_earrings_003&orientation=squarish'],
    created_at: '2024-01-17T12:00:00Z',
    updated_at: '2024-01-17T12:00:00Z'
  },
  {
    id: 'prod_004',
    model_name: 'Tennis Bracelet',
    category: 'Bracelets',
    metal_type: 'Platinum',
    purity: '950',
    grossWeight: 8.2,
    netWeight: 6.2,
    stoneWeight: 2.0,
    stone_details: 'Diamond 2.0ct total',
    making_charges: 5000,
    vendor_name: 'Luxury Lines',
    description: 'Premium platinum tennis bracelet with diamonds',
    price: 125000,
    cost: 110000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=luxury%20platinum%20tennis%20bracelet%20with%20round%20brilliant%20diamonds%2C%20continuous%20line%20of%20sparkling%20stones%2C%20secure%20clasp%2C%20high-end%20jewelry%2C%20professional%20photography%20on%20white%20background%2C%20premium%20bracelet%20design&width=400&height=400&seq=tennis_bracelet_004&orientation=squarish'],
    created_at: '2024-01-18T13:00:00Z',
    updated_at: '2024-01-18T13:00:00Z'
  },
  {
    id: 'prod_005',
    model_name: 'Heart Pendant',
    category: 'Pendants',
    metal_type: 'Gold',
    purity: '14K',
    grossWeight: 2.1,
    netWeight: 1.9,
    stoneWeight: 0.2,
    stone_details: 'Ruby 0.25ct',
    making_charges: 1200,
    vendor_name: 'Love Craft',
    description: 'Romantic heart pendant with ruby center',
    price: 18500,
    cost: 15000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=romantic%20heart-shaped%20pendant%20with%20red%20ruby%20gemstone%20center%2C%2014k%20yellow%20gold%20setting%2C%20delicate%20chain%20included%2C%20love%20jewelry%2C%20valentine%20gift%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=heart_pendant_005&orientation=squarish'],
    created_at: '2024-01-19T14:00:00Z',
    updated_at: '2024-01-19T14:00:00Z'
  },
  {
    id: 'prod_006',
    model_name: 'Emerald Stud Earrings',
    category: 'Earrings',
    metal_type: 'Gold',
    purity: '18K',
    grossWeight: 4.5,
    netWeight: 3.8,
    stoneWeight: 0.7,
    stone_details: 'Emerald 0.75ct total',
    making_charges: 1500,
    vendor_name: 'Gem Masters',
    description: 'Beautiful emerald stud earrings in 18K gold',
    price: 32000,
    cost: 28000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=beautiful%20emerald%20stud%20earrings%20with%20square%20cut%20green%20emeralds%2C%2018k%20yellow%20gold%20prong%20setting%2C%20matching%20pair%2C%20precious%20gemstone%20jewelry%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=emerald_studs_006&orientation=squarish'],
    created_at: '2024-01-20T15:00:00Z',
    updated_at: '2024-01-20T15:00:00Z'
  },
  {
    id: 'prod_007',
    model_name: 'Sapphire Cocktail Ring',
    category: 'Rings',
    metal_type: 'Gold',
    purity: '18K',
    grossWeight: 7.8,
    netWeight: 6.5,
    stoneWeight: 1.3,
    stone_details: 'Blue Sapphire 2.5ct',
    making_charges: 3500,
    vendor_name: 'Royal Gems',
    description: 'Magnificent blue sapphire cocktail ring',
    price: 95000,
    cost: 82000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=magnificent%20blue%20sapphire%20cocktail%20ring%2C%20large%20oval%20cut%20sapphire%20center%20stone%2C%2018k%20white%20gold%20setting%20with%20diamond%20accents%2C%20luxury%20statement%20ring%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=sapphire_ring_007&orientation=squarish'],
    created_at: '2024-01-21T16:00:00Z',
    updated_at: '2024-01-21T16:00:00Z'
  },
  {
    id: 'prod_008',
    model_name: 'Diamond Choker Necklace',
    category: 'Necklaces',
    metal_type: 'Gold',
    purity: '18K',
    grossWeight: 15.2,
    netWeight: 12.8,
    stoneWeight: 2.4,
    stone_details: 'Diamond 3.5ct total',
    making_charges: 8000,
    vendor_name: 'Diamond Dynasty',
    description: 'Exquisite diamond choker with intricate design',
    price: 285000,
    cost: 245000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=exquisite%20diamond%20choker%20necklace%2C%20multiple%20rows%20of%20brilliant%20cut%20diamonds%2C%2018k%20white%20gold%20setting%2C%20luxury%20bridal%20jewelry%2C%20elegant%20neck%20piece%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=diamond_choker_008&orientation=squarish'],
    created_at: '2024-01-22T17:00:00Z',
    updated_at: '2024-01-22T17:00:00Z'
  },
  {
    id: 'prod_009',
    model_name: 'Rose Gold Bangle Set',
    category: 'Bracelets',
    metal_type: 'Gold',
    purity: '18K',
    grossWeight: 25.6,
    netWeight: 25.6,
    stoneWeight: 0,
    stone_details: 'None',
    making_charges: 4500,
    vendor_name: 'Rose Elegance',
    description: 'Set of 4 rose gold bangles with textured finish',
    price: 165000,
    cost: 148000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=set%20of%20four%20rose%20gold%20bangles%2C%20textured%20finish%20design%2C%2018k%20rose%20gold%20metal%2C%20elegant%20stacking%20bangles%2C%20modern%20jewelry%20style%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=rose_bangles_009&orientation=squarish'],
    created_at: '2024-01-23T18:00:00Z',
    updated_at: '2024-01-23T18:00:00Z'
  },
  {
    id: 'prod_010',
    model_name: 'Vintage Brooch',
    category: 'Brooches',
    metal_type: 'Gold',
    purity: '14K',
    grossWeight: 6.3,
    netWeight: 5.1,
    stoneWeight: 1.2,
    stone_details: 'Mixed gems 1.8ct',
    making_charges: 2800,
    vendor_name: 'Antique Arts',
    description: 'Vintage-style brooch with mixed gemstones',
    price: 42000,
    cost: 36000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=vintage%20style%20brooch%20with%20mixed%20colorful%20gemstones%2C%2014k%20yellow%20gold%20filigree%20setting%2C%20antique%20jewelry%20design%2C%20ornate%20decorative%20pin%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=vintage_brooch_010&orientation=squarish'],
    created_at: '2024-01-24T19:00:00Z',
    updated_at: '2024-01-24T19:00:00Z'
  },
  {
    id: 'prod_011',
    model_name: 'Platinum Wedding Band',
    category: 'Rings',
    metal_type: 'Platinum',
    purity: '950',
    grossWeight: 4.2,
    netWeight: 4.2,
    stoneWeight: 0,
    stone_details: 'None',
    making_charges: 1800,
    vendor_name: 'Eternal Bonds',
    description: 'Classic platinum wedding band with comfort fit',
    price: 35000,
    cost: 31000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=classic%20platinum%20wedding%20band%20ring%2C%20smooth%20polished%20finish%2C%20comfort%20fit%20design%2C%20simple%20elegant%20style%2C%20bridal%20jewelry%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=platinum_band_011&orientation=squarish'],
    created_at: '2024-01-25T20:00:00Z',
    updated_at: '2024-01-25T20:00:00Z'
  },
  {
    id: 'prod_012',
    model_name: 'Coral Beaded Necklace',
    category: 'Necklaces',
    metal_type: 'Gold',
    purity: '22K',
    grossWeight: 18.7,
    netWeight: 16.2,
    stoneWeight: 2.5,
    stone_details: 'Coral beads 45ct',
    making_charges: 3200,
    vendor_name: 'Ocean Treasures',
    description: 'Traditional coral beaded necklace with gold spacers',
    price: 125000,
    cost: 112000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=traditional%20coral%20beaded%20necklace%2C%20red%20coral%20beads%20with%2022k%20gold%20spacers%2C%20Indian%20traditional%20jewelry%2C%20ethnic%20design%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=coral_necklace_012&orientation=squarish'],
    created_at: '2024-01-26T21:00:00Z',
    updated_at: '2024-01-26T21:00:00Z'
  },
  {
    id: 'prod_013',
    model_name: 'Amethyst Pendant Set',
    category: 'Pendants',
    metal_type: 'Silver',
    purity: '925',
    grossWeight: 8.4,
    netWeight: 6.8,
    stoneWeight: 1.6,
    stone_details: 'Amethyst 4.2ct',
    making_charges: 1500,
    vendor_name: 'Purple Dreams',
    description: 'Amethyst pendant with matching earrings',
    price: 18500,
    cost: 15200,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=amethyst%20pendant%20set%20with%20matching%20earrings%2C%20purple%20gemstone%20center%2C%20sterling%20silver%20setting%2C%20elegant%20jewelry%20set%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=amethyst_set_013&orientation=squarish'],
    created_at: '2024-01-27T22:00:00Z',
    updated_at: '2024-01-27T22:00:00Z'
  },
  {
    id: 'prod_014',
    model_name: 'Gold Coin Bracelet',
    category: 'Bracelets',
    metal_type: 'Gold',
    purity: '22K',
    grossWeight: 22.3,
    netWeight: 22.3,
    stoneWeight: 0,
    stone_details: 'None',
    making_charges: 3800,
    vendor_name: 'Coin Craft',
    description: 'Bracelet with 7 gold coins featuring Lakshmi design',
    price: 145000,
    cost: 132000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=gold%20coin%20bracelet%20with%20seven%20Lakshmi%20coins%2C%2022k%20yellow%20gold%2C%20traditional%20Indian%20design%2C%20religious%20jewelry%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=coin_bracelet_014&orientation=squarish'],
    created_at: '2024-01-28T23:00:00Z',
    updated_at: '2024-01-28T23:00:00Z'
  },
  {
    id: 'prod_015',
    model_name: 'Citrine Cocktail Ring',
    category: 'Rings',
    metal_type: 'Gold',
    purity: '14K',
    grossWeight: 6.8,
    netWeight: 5.5,
    stoneWeight: 1.3,
    stone_details: 'Citrine 3.8ct',
    making_charges: 2200,
    vendor_name: 'Sunny Stones',
    description: 'Bold citrine cocktail ring in yellow gold',
    price: 38000,
    cost: 32500,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=bold%20citrine%20cocktail%20ring%2C%20large%20yellow%20gemstone%20center%2C%2014k%20yellow%20gold%20setting%2C%20statement%20ring%20design%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=citrine_ring_015&orientation=squarish'],
    created_at: '2024-01-29T10:00:00Z',
    updated_at: '2024-01-29T10:00:00Z'
  },
  {
    id: 'prod_016',
    model_name: 'Pearl Strand Necklace',
    category: 'Necklaces',
    metal_type: 'Gold',
    purity: '18K',
    grossWeight: 12.8,
    netWeight: 8.2,
    stoneWeight: 4.6,
    stone_details: 'Cultured Pearls 8-9mm',
    making_charges: 2500,
    vendor_name: 'Pearl Perfection',
    description: 'Classic pearl strand with gold clasp',
    price: 65000,
    cost: 56000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=classic%20pearl%20strand%20necklace%2C%20cultured%20white%20pearls%208-9mm%2C%2018k%20gold%20clasp%2C%20elegant%20bridal%20jewelry%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=pearl_strand_016&orientation=squarish'],
    created_at: '2024-01-30T11:00:00Z',
    updated_at: '2024-01-30T11:00:00Z'
  },
  {
    id: 'prod_017',
    model_name: 'Turquoise Cuff Bracelet',
    category: 'Bracelets',
    metal_type: 'Silver',
    purity: '925',
    grossWeight: 15.6,
    netWeight: 12.8,
    stoneWeight: 2.8,
    stone_details: 'Turquoise 12ct',
    making_charges: 1800,
    vendor_name: 'Desert Gems',
    description: 'Southwestern style turquoise cuff bracelet',
    price: 22000,
    cost: 18500,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=southwestern%20style%20turquoise%20cuff%20bracelet%2C%20blue%20turquoise%20stones%2C%20sterling%20silver%20setting%2C%20Native%20American%20inspired%20design%2C%20professional%20jewelry%20photography%20on%20white%20background&width=400&height=400&seq=turquoise_cuff_017&orientation=squarish'],
    created_at: '2024-01-31T12:00:00Z',
    updated_at: '2024-01-31T12:00:00Z'
  },
  {
    id: 'prod_018',
    model_name: 'Diamond Hoop Earrings',
    category: 'Earrings',
    metal_type: 'Gold',
    purity: '18K',
    grossWeight: 6.2,
    netWeight: 5.1,
    stoneWeight: 1.1,
    stone_details: 'Diamond 1.5ct total',
    making_charges: 3200,
    vendor_name: 'Circle Elegance',
    description: 'Classic diamond hoop earrings with secure closure',
    price: 85000,
    cost: 74000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=classic%20diamond%20hoop%20earrings%2C%20brilliant%20cut%20diamonds%2C%2018k%20white%20gold%20setting%2C%20secure%20hinged%20closure%2C%20elegant%20everyday%20jewelry%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=diamond_hoops_018&orientation=squarish'],
    created_at: '2024-02-01T13:00:00Z',
    updated_at: '2024-02-01T13:00:00Z'
  },
  {
    id: 'prod_019',
    model_name: 'Garnet Cluster Ring',
    category: 'Rings',
    metal_type: 'Gold',
    purity: '14K',
    grossWeight: 5.4,
    netWeight: 4.2,
    stoneWeight: 1.2,
    stone_details: 'Garnet 2.8ct total',
    making_charges: 1800,
    vendor_name: 'Red Fire Gems',
    description: 'Vintage-inspired garnet cluster ring',
    price: 28000,
    cost: 24000,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=vintage%20inspired%20garnet%20cluster%20ring%2C%20multiple%20red%20garnets%2C%2014k%20yellow%20gold%20setting%2C%20antique%20style%20jewelry%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=garnet_cluster_019&orientation=squarish'],
    created_at: '2024-02-02T14:00:00Z',
    updated_at: '2024-02-02T14:00:00Z'
  },
  {
    id: 'prod_020',
    model_name: 'Moonstone Pendant',
    category: 'Pendants',
    metal_type: 'Silver',
    purity: '925',
    grossWeight: 4.8,
    netWeight: 3.6,
    stoneWeight: 1.2,
    stone_details: 'Moonstone 3.5ct',
    making_charges: 1200,
    vendor_name: 'Lunar Lights',
    description: 'Mystical moonstone pendant with chain',
    price: 15000,
    cost: 12500,
    status: 'active',
    images: ['https://readdy.ai/api/search-image?query=mystical%20moonstone%20pendant%2C%20oval%20cut%20moonstone%20with%20blue%20flash%2C%20sterling%20silver%20setting%2C%20delicate%20chain%20included%2C%20bohemian%20jewelry%20style%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=moonstone_pendant_020&orientation=squarish'],
    created_at: '2024-02-03T15:00:00Z',
    updated_at: '2024-02-03T15:00:00Z'
  }
];

// Utility function to validate weight calculations
export const validateWeights = (grossWeight: number, netWeight: number, stoneWeight: number): boolean => {
  const calculatedGross = netWeight + stoneWeight;
  return Math.abs(grossWeight - calculatedGross) < 0.01;
};

// Utility function to calculate gross weight
export const calculateGrossWeight = (netWeight: number, stoneWeight: number): number => {
  return parseFloat((netWeight + stoneWeight).toFixed(2));
};

export const mockInvoices = [
  {
    id: 'inv_001',
    invoice_no: 'INV-2024-0001',
    customer_name: 'Rajesh Kumar',
    customer_phone: '+91-9876543210',
    customer_address: '123 MG Road, Bangalore',
    date: '2024-01-20',
    total_amount: 45000,
    status: 'paid',
    created_at: '2024-01-20T10:00:00Z',
    updated_at: '2024-01-20T10:00:00Z'
  },
  {
    id: 'inv_002',
    invoice_no: 'INV-2024-0002',
    customer_name: 'Priya Sharma',
    customer_phone: '+91-9876543211',
    customer_address: '456 Brigade Road, Bangalore',
    date: '2024-01-21',
    total_amount: 85000,
    status: 'sent',
    created_at: '2024-01-21T11:00:00Z',
    updated_at: '2024-01-21T11:00:00Z'
  },
  {
    id: 'inv_003',
    invoice_no: 'INV-2024-0003',
    customer_name: 'Amit Patel',
    customer_phone: '+91-9876543212',
    customer_address: '789 Commercial Street, Bangalore',
    date: '2024-01-22',
    total_amount: 12000,
    status: 'draft',
    created_at: '2024-01-22T12:00:00Z',
    updated_at: '2024-01-22T12:00:00Z'
  }
];

export const mockCustomers = [
  {
    id: 'cust_001',
    name: 'Rajesh Kumar',
    email: 'rajesh.kumar@email.com',
    phone: '+91-9876543210',
    address: '123 MG Road, Bangalore',
    created_at: '2024-01-15T10:00:00Z',
    updated_at: '2024-01-15T10:00:00Z'
  },
  {
    id: 'cust_002',
    name: 'Priya Sharma',
    email: 'priya.sharma@email.com',
    phone: '+91-9876543211',
    address: '456 Brigade Road, Bangalore',
    created_at: '2024-01-16T11:00:00Z',
    updated_at: '2024-01-16T11:00:00Z'
  },
  {
    id: 'cust_003',
    name: 'Amit Patel',
    email: 'amit.patel@email.com',
    phone: '+91-9876543212',
    address: '789 Commercial Street, Bangalore',
    created_at: '2024-01-17T12:00:00Z',
    updated_at: '2024-01-17T12:00:00Z'
  }
];
